<template>
  <v-container fluid class="pa-0 test" style="background-color:#fff">
    <v-card color="white" flat>
      <v-toolbar class="custom" color="white" elevation="0" fixed height="120">
        <v-toolbar-title class=" purple--text mr-2" style="overflow:show;">
          <v-img :src="require('../assets/logo.png')" width="70px"> </v-img>
        </v-toolbar-title>
        <v-toolbar-title
          class="font-weight-bold"
          style="font-size:1.3rem;bottom: -5px; position:relative;width:260px;"
        >
          SINAR FASTENER
          <div
            class="mt-0 primary--text"
            style="letter-spacing: 8px;font-weight: 400px;top: -7px; position:relative;"
          >
            INDONESIA
          </div>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-divider vertical inset></v-divider>
        <v-list three-line max-width="20%">
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="#0081db">mdi-phone</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold mb-2">
                Kontak Kami
              </v-list-item-title>
              <v-list-item-subtitle>021-599-0860</v-list-item-subtitle>
              <v-list-item-subtitle>0878-7659-3469</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list three-line max-width="27%" class="mr-10">
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="#0081db">mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold mb-2">
                Kantor Kami
              </v-list-item-title>
              <v-list-item-subtitle
                >Perum Tigaraksa Blok AJ 47/10 Tangerang,
                Banten</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-btn
          color="#0081db"
          outlined
          tile
          class="font-weight-regular"
          to="/contact"
        >
          HUBUNGI KAMI
        </v-btn>
      </v-toolbar>
      <v-divider class="mx-auto" width="90%"></v-divider>
      <v-toolbar class="custom" color="white" elevation="0" height="80">
        <v-btn text tile to="/" class="font-weight-bold" height="80">
          BERANDA
        </v-btn>
        <v-btn text tile to="/services" class="font-weight-bold" height="80">
          LAYANAN
        </v-btn>
        <v-btn text tile to="/projects" class="font-weight-bold" height="80">
          PORTOFOLIO
        </v-btn>
        <v-btn text tile to="/about" class="font-weight-bold" height="80">
          TENTANG
        </v-btn>
        <v-btn
          text
          color="#0081db"
          tile
          class="font-weight-bold"
          to="/contact"
          height="80"
          v-scroll-to="{ el: '#element', offset: -30 }"
        >
          KONTAK
        </v-btn>
        <v-spacer />
        <v-icon @click="alert" color="black">
          mdi-magnify
        </v-icon>
      </v-toolbar>
      <v-card width="100%" color="#f8f8f8" elevation="0" class="paralaxGrad">
        <v-row align="center" justify="space-between" class="paralax">
          <h1
            class="display-1 font-weight-bold pa-4 white--text ml-4"
            color="primary"
          >
            KONTAK
          </h1>
          <v-breadcrumbs :items="breadcumbs">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-row>
      </v-card>
    </v-card>
    <v-row class="custom">
      <v-col cols="4" class="pa-4">
        <v-card elevation="0" color="#f7f7f7" class="pa-2">
          <v-card-text>
            <p class="title text--primary font-weight-bold">
              KANTOR KAMI
            </p>
            <p class="my-0">Perum Tigaraksa BLOK AJ 47/10</p>
            <p class="my-0">Kelurahan Margasari, Kecamatan Tigaraksa</p>
            <p>Tangerang , Banten</p>
            <div class="text--primary">
              Nomor Telepon : 021-5990860 / 087876593469<br />
              Email:
              <a href="mailto:marketing@sinarfastenerindonesia.com">
                marketing@sinarfastenerindonesia.com
              </a>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="8">
        <v-card-text class="title font-weight-bold"
          >Pertanyaan</v-card-text
        >
        <v-divider class="ml-4 mt-0"></v-divider>
        <v-form>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" class="py-2">
                <v-text-field
                  v-model="nama"
                  placeholder="Nama anda"
                  label="Nama"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" class="py-2">
                <v-textarea
                  v-model="pesan"
                  outlined
                  name="input-7-4"
                  label="Pertanyaan"
                  placeholder="Pertanyaan anda"
                ></v-textarea>
                <v-btn
                  class="my-0 py-0"
                  color="#0081db"
                  outlined
                  tile
                  :href="`https://api.whatsapp.com/send?phone=6287876593469&text=Halo,%20Saya%20${nama}%0A%0A${pesan}`"
                >
                  KIRIM
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-footer padless>
      <v-card flat tile class="text-center pt-10" color="black">
        <v-row class="text-left custom-margin-footer">
          <v-col cols="4">
            <v-card-text>
              <h2 class="white--text">TENTANG</h2>
              <p class="darken-4 grey--text mt-3">
                PT. Sinar Fastener Indonesia adalah perusahaan yang bergerak di
                bidang pengadaan barang konstruksi dan jasa kontraktor yang
                melayani perusahaan kecil, menengah dan perusahaan besar, baik
                swasta dan pemerintahan dengan diawali dengan berdirinya usaha
                CV. Sinar Galvanis Metal sejak tahun 2002. Kami menyediakan
                solusi bisnis yang jujur dan amanah kepada perusahaan yang
                menjadi mitra kami dimana hal yang menjadi keutamaan kami selalu
                mengutamakan kepuasan pelanggan serta kepercayaan demi
                kelangsungan bisnis yang harmonis dan berkelanjutan
              </p>
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <h2 class="white--text">HELPFUL LINKS</h2>
              <ul class="darken-4 grey--text mt-3">
                <li class="mb-3">
                  <h3>
                    <a
                      href="/#/services"
                      class="blue--text"
                      style="text-decoration: none"
                      >Layanan</a
                    >
                  </h3>
                </li>
                <li class="mb-3">
                  <h3>
                    <a
                      href="/#/projects"
                      class="blue--text"
                      style="text-decoration: none"
                      >Portofolio</a
                    >
                  </h3>
                </li>
                <li class="mb-3">
                  <h3>
                    <a
                      href="/#/about"
                      class="blue--text"
                      style="text-decoration: none"
                      >Tentang</a
                    >
                  </h3>
                </li>
                <li>
                  <h3>
                    <a
                      href="/#/contact"
                      class="blue--text"
                      style="text-decoration: none"
                      >Kontak</a
                    >
                  </h3>
                </li>
              </ul>
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <h2 class="white--text">KONTAK KAMI</h2>
              <p class="mt-3 darken-2 grey--text">
                Perum Tigaraksa BLOK AJ 47/10, Kel. Margasari, Kec. Tigaraksa,
                Kab. Tangerang, Prov. Banten
              </p>
              <p class="mt-3 darken-2 grey--text">
                Phone:
                <span class="white--text"> 021-599-0860 / 0878-7659-3469</span>
              </p>
              <p class="mt-3 darken-2 grey--text">
                Email:
                <a
                  href="mailto:marketing@sinarfastenerindonesia.com"
                  class="white--text"
                >
                  marketing@sinarfastenerindonesia.com
                </a>
              </p>
            </v-card-text>
          </v-col>
        </v-row>
        <v-divider color="grey"></v-divider>
        <v-card-text>
          <v-btn
            v-for="icon in iconsFooter"
            :key="icon"
            class="mx-4 blue--text"
            icon
          >
            <v-icon size="24px">{{ icon }}</v-icon>
          </v-btn>
        </v-card-text>
        <div>
          <v-divider color="grey"></v-divider>
          <v-card-text class="darken-4 grey--text">
            © Copyright 2020 by
            <a
              href="#"
              class="blue--text font-weight-bold"
              style="text-decoration: none"
              >Sinar Fastener</a
            >. All Rights Reserved.
          </v-card-text>
        </div>
      </v-card>
    </v-footer>
    <!-- <v-parallax
      dark
      src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col class="text-center" cols="12">
          <h1 class="display-1 font-weight-thin mb-4">Vuetify.js</h1>
          <h4 class="subheading">Build your application today!</h4>
        </v-col>
      </v-row>
    </v-parallax> -->
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      nama: '',
      pesan: '',
      colors: ["#582960", "#341992"],
      icons: ["mdi-rewind"],
      breadcumbs: [
        {
          text: "Homepage",
          disabled: false,
          href: "homepage",
        },
        {
          text: "Contact",
          disabled: true,
          href: "contact",
        },
      ],
      iconsFooter: [
        "mdi-facebook",
        "mdi-twitter",
        "mdi-google-plus",
        "mdi-linkedin",
        "mdi-instagram",
      ],
      itemProject: [
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me" },
        { title: "Click Me 2" },
      ],
      itemServices: [
        { title: "Repair" },
        { title: "Painting" },
        { title: "Carpentry" },
        { title: "Plumbing" },
        { title: "Remodeling" },
        { title: "Electrical" },
      ],
      itemsSubject: ["Repair", "Painting", "Renovation", "Plumbing"],
      transparent: "rgba(255, 255, 255, 0)",
      itemsToolbar: [
        { icon: "mdi-truck-delivery", text: "Responsive Maintenance" },
        { icon: "mdi-account-multiple-check", text: "Trusted Staff" },
        { icon: "mdi-check-decagram", text: "100% Guarantee" },
        { icon: "mdi-shield-check", text: "Protected Payment" },
        { icon: "mdi-tag-multiple", text: "Low Cost" },
      ],
      categories: [
        {
          icon: "mdi-math-compass",
          title: "REPAIR",
          subtitle: "A fresh coat of paint can breathe life into any room.",
        },
        {
          icon: "mdi-math-compass",
          title: "PAINTING",
          subtitle: "A fresh coat of paint can breathe life into any room.",
        },
        {
          icon: "mdi-math-compass",
          title: "CARPENTRY",
          subtitle: "A fresh coat of paint can breathe life into any room.",
        },
        {
          icon: "mdi-math-compass",
          title: "PLUMBING",
          subtitle: "A fresh coat of paint can breathe life into any room.",
        },
        {
          icon: "mdi-math-compass",
          title: "REMODELING",
          subtitle: "A fresh coat of paint can breathe life into any room.",
        },
        {
          icon: "mdi-math-compass",
          title: "ELECTRICAL",
          subtitle: "A fresh coat of paint can breathe life into any room.",
        },
      ],
      // logo: base
      item: {
        title: "Halo, Justiperz!",
        subtitle: "PROFESSIONAL TILING",
      },
      contactImage: require("@/assets/contact.jpg"),
    };
  },
  methods: {
    alert() {
      alert("haii");
    },
  },
};
</script>

<style scoped>
.v-card--offset {
  opacity: 0.9;
  top: -450px;
  z-index: 5;
  left: 205px;
  border-top: 5px solid #0081db;
  color: white;
  position: relative;
}
.tagline-margin {
  margin-top: 30px;
}
.chat {
  top: -230px;
  position: relative;
  z-index: 1;
}
.custom {
  margin-inline-start: 170px;
  margin-inline-end: 170px;
}
.custom-margin-footer {
  margin-inline-start: 120px;
  margin-inline-end: 120px;
}
.paralax {
  height: 230px;
  margin-inline-start: 170px;
  margin-inline-end: 190px;
}
.paralaxGrad {
  background: linear-gradient(
    to right,
    navy,
    rgb(109, 199, 215),
    rgb(247, 247, 247)
  );
}
.gradient {
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4) 0%,
    transparent 72px
  );
}
.customProject {
  margin-inline-start: 30%;
}
.categories.hover-image {
  background-color: blue;
}
.outline {
  border: 1.5px solid purple;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
.v-img--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}
.margin-auto {
  margin: auto;
}
.hover-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.card-1 {
  top: -240px;
  position: relative;
}
.satisfation {
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#3762d9),
    color-stop(35%, #6f66be),
    to(#8c00ff)
  );
  /* background : -webkit-gradient(linear,left top,right top,from(#e100ff),color-stop(35%,#bc64d6),to(#9e37d9)); */
  border-radius: 10px;
  top: -200px;
  position: relative;
}
.project {
  top: -150px;
  position: relative;
}
.active {
  border: 1px blue;
}
.v-card-custom {
  transition: opacity 0.4s ease-in-out;
}

.v-card-custom:not(.on-hover) {
  opacity: 0.6;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
.garis {
  border: 3px solid navy;
}
.footer-padding {
  padding-inline-start: 200px;
  padding-inline-end: 200px;
}
.test {
  border-top: blue;
}
</style>
